import React, { useEffect } from "react";
import "aos/dist/aos.css";
import AOS from "aos";
import "bootstrap/dist/css/bootstrap.min.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import "./AboutCommodity.css";
import Footer from "../Home/Footer";
import WhyPulses from "../assets/img/AboutUsSlider3.png";
import Slider1 from "../assets/img/AboutCommoditySlider-1.jpg";
import Slider2 from "../assets/img/AboutCommoditySlider-2.jpg";
import Slider3 from "../assets/img/AboutCommoditySlider-3.jpg";
import Variety1 from "../assets/img/PulsesVariety1.png";
import Variety2 from "../assets/img/PulsesVariety2.png";
import Variety3 from "../assets/img/PulsesVariety3.png";
import Variety4 from "../assets/img/PulsesVariety4.png";
import Variety5 from "../assets/img/PulsesVariety5.png";
import Variety6 from "../assets/img/PulsesVariety6.png";
import Variety7 from "../assets/img/PulsesVariety7.png";
import Variety8 from "../assets/img/PulsesVariety8.png";
import Variety9 from "../assets/img/PulsesVariety9.png";
import Variety10 from "../assets/img/PulsesVariety10.png";
import Variety11 from "../assets/img/PulsesVariety11.png";
import Variety12 from "../assets/img/PulsesVariety12.png";
import Variety13 from "../assets/img/PulsesVariety13.png";
import Variety14 from "../assets/img/PulsesVariety14.png";
import Variety15 from "../assets/img/PulsesVariety15.png";
import Variety16 from "../assets/img/PulsesVariety16.png";
import Variety17 from "../assets/img/PulsesVariety17.png";
import Variety18 from "../assets/img/PulsesVariety18.png";
import Variety19 from "../assets/img/PulsesVariety19.png";

const AboutCommodity = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);
  const carouselData = [
    {
      id: 1,
      image: Slider1,
      title: "Pulses: The Powerhouse Crops",
      description:
        "Explore the varieties, benefits, and market insights of pulses.",
    },
    {
      id: 2,
      image: Slider2,
      title: "High Yield & Sustainability",
      description:
        "Pulses provide a rich source of protein and are a vital part of global agriculture.",
    },
    {
      id: 3,
      image: Slider3,
      title: "Versatile Applications",
      description:
        "From food to feed, pulses play a crucial role in multiple industries.",
    },
  ];

  const soybeanVarieties = [
    {
      id: 1,
      image: Variety1,
      title: "Pigeon Peas (Toor/Arhar Dal)",
      shortDesc: "A staple in Indian households",
      title: "Pigeon Peas (Toor/Arhar Dal)",
      fullDesc:
        "A staple in Indian households, rich in protein and iron. Commonly used in dals and sambars.",
    },
    {
      id: 2,
      image: Variety2,
      title: "Green Gram (Moong Dal)",
      shortDesc: "Ideal for sustainable and organic markets.",
      fullDesc:
        "Light, easy to digest, and packed with nutrients. Ideal for soups, khichdi, and sprouts.",
    },
    {
      id: 3,
      image: Variety3,
      title: "Split Green Gram (Moong Dal Chilka)",
      shortDesc: "Best for oil extraction with high oil yield.",
      fullDesc:
        "Retains the green skin, offering more fiber. Cooks quickly and is great for light dals.",
    },
    {
      id: 4,
      image: Variety4,
      title: "Yellow Lentil (Moong Dhuli Dal)",
      shortDesc: "Best for oil extraction with high oil yield.",
      fullDesc:
        "Skinned and split moong, soft and quick to cook. Perfect for babies and those on light diets. ",
    },
    {
      id: 5,
      image: Variety5,
      title: "Whole Red Lentil (Masoor Sabut)",
      shortDesc: "Best for oil extraction with high oil yield.",
      fullDesc:
        "Earthy flavor and high in iron and protein. Used in hearty stews and curries. ",
    },
    {
      id: 6,
      image: Variety6,
      title: "Bengal Gram (Chana Dal)",
      shortDesc: "Best for oil extraction with high oil yield.",
      fullDesc:
        "Nutty and dense, made from split brown chickpeas. Used in dals, snacks, and sweets. ",
    },
    {
      id: 7,
      image: Variety7,
      title: "Black Matpe Beans (Sabut Urad)",
      shortDesc: "Best for oil extraction with high oil yield.",
      fullDesc:
        "Whole urad with skin, rich and creamy when cooked. Main ingredient in dal makhani. ",
    },
    {
      id: 8,
      image: Variety8,
      title: "Skinned Gram (Urad)",
      shortDesc: "Best for oil extraction with high oil yield.",
      fullDesc:
        "White urad used in idli and dosa batter. Ferments well and gives a fluffy texture. ",
    },
    {
      id: 9,
      image: Variety9,
      title: "Field Beans (Val Dal)",
      shortDesc: "Best for oil extraction with high oil yield.",
      fullDesc:
        "Popular in Maharashtrian and Gujarati cuisine. Adds a unique flavor to curries and rice dishes.",
    },
    {
      id: 10,
      image: Variety10,
      title: "Dew Gram Beans (Moth Beans)",
      shortDesc: "Best for oil extraction with high oil yield.",
      fullDesc:
        "Small, brown beans rich in protein. Often sprouted and used in misal.",
    },
    {
      id: 11,
      image: Variety11,
      title: "Horse Gram (Kulthi/Kulath/Kollu)",
      shortDesc: "Best for oil extraction with high oil yield.",
      fullDesc:
        "High in iron and calcium, with a strong flavor. Used in traditional soups and rasam.",
    },
    {
      id: 12,
      image: Variety12,
      title: "Garbanzo Beans (Kabuli Chana/Chole)",
      shortDesc: "Best for oil extraction with high oil yield.",
      fullDesc:
        "Creamy and nutty, used in chole and hummus. Rich in protein and fiber.",
    },
    {
      id: 13,
      image: Variety13,
      title: "Black Chickpeas (Kala Chana)",
      shortDesc: "Best for oil extraction with high oil yield.",
      fullDesc:
        "Dense and earthy, holds shape well when cooked. Great for curries and dry stir-fries.",
    },
    {
      id: 14,
      image: Variety14,
      title: "Dried Green Chickpeas (Hara Chana)",
      shortDesc: "Best for oil extraction with high oil yield.",
      fullDesc:
        "Seasonal and flavorful, rich in nutrients. Used in curries and stir-fried dishes.",
    },
    {
      id: 15,
      image: Variety15,
      title: "Red Kidney Beans (Rajma)",
      shortDesc: "Best for oil extraction with high oil yield.",
      fullDesc:
        "Popular in North India, especially with rice. Rich in protein and fiber.",
    },
    {
      id: 16,
      image: Variety16,
      title: "Black-Eyed Peas (Lobia/Chawli/Raungi)",
      shortDesc: "Best for oil extraction with high oil yield.",
      fullDesc:
        "Mild flavor and quick to cook. Used in salads, curries, and stews.",
    },
    {
      id: 17,
      image: Variety17,
      title: "Adzuki Beans (Chori)",
      shortDesc: "Best for oil extraction with high oil yield.",
      fullDesc:
        "Small red beans with a sweet, nutty taste. Used in Asian desserts and savory dishes.",
    },
    {
      id: 18,
      image: Variety18,
      title: "Dried Green Peas (Vatana)",
      shortDesc: "Best for oil extraction with high oil yield.",
      fullDesc:
        "Common in street foods like ragda. Adds a creamy texture when cooked.",
    },
    {
      id: 19,
      image: Variety19,
      title: "Dried White Peas (Safed Vatana)",
      shortDesc: "Best for oil extraction with high oil yield.",
      fullDesc:
        "Used in Mumbai’s ragda patties and chaats. Soaks up flavors beautifully.",
    },
  ];

  return (
    <div className="about-commodity">
      {/* Hero Section */}
      <section className="carousel-section">
        <Swiper
          modules={[Pagination, Autoplay]}
          pagination={{ clickable: true }}
          navigation={false}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          loop={true}
          className="custom-swiper"
        >
          {carouselData.map((slide, index) => (
            <SwiperSlide key={index}>
              <div
                className="carousel-item"
                style={{ backgroundImage: `url('${slide.image}')` }}
              >
                <div className="overlay">
                  <h2 style={{ color: "white" }}>{slide.title}</h2>
                  <p>{slide.description}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      {/* Soybean Overview */}
      <section className="soybean-overview container-soybean">
        <div className="overview-content" data-aos="fade-right">
          <h2 style={{ color: "white" }}>Why Pulses?</h2>
          <p style={{ color: "#FFF5EE" }}>
            Pulses are a group of nutrient-dense legumes that include lentils,
            beans, chickpeas, and peas. They are an excellent source of
            plant-based protein, dietary fiber, and essential vitamins and
            minerals, making them a vital part of a healthy diet. Economically,
            they are affordable and accessible, supporting food security and
            providing income for millions of farmers worldwide. Their
            versatility in cooking and health benefits make pulses a smart and
            sustainable choice for both people and the planet.
          </p>
          <ul className="soybean-benefits" style={{ color: "#FFF5EE" }}>
            <li>
              Essential for muscle repair and growth, especially important in
              vegetarian and vegan diets.
            </li>
            <li>
              They enrich soil by fixing atmospheric nitrogen, reducing the need
              for synthetic fertilizers.
            </li>
            <li>Pulses are cost-effective sources of protein.</li>
            <li>
              Used in a wide range of dishes: soups, salads, curries, stews,
              snacks.
            </li>
            <li>It helps lower cholesterol and blood pressure.</li>
          </ul>
        </div>

        <div className="overview-image" data-aos="fade-left">
          <img src={WhyPulses} alt="Soybean Plant" />
        </div>
      </section>

      {/* Variety Information */}
      <section className="variety-section">
        <div className="container">
          <h2
            className="separator-title text-center"
            data-aos="fade-up"
            style={{ color: "#d4561a" }}
          >
            Pulses Varieties
          </h2>
          <div className="separator-line mb-5"></div>
          <div className="variety-cards">
            {soybeanVarieties.map((variety) => (
              <div key={variety.id} className="variety-card" data-aos="zoom-in">
                <div className="card-inner">
                  <div
                    className="card-front"
                    style={{ backgroundImage: `url(${variety.image})` }}
                  >
                    {/* <h3>{variety.title}</h3>
                    <p>{variety.shortDesc}</p> */}
                  </div>
                  <div className="card-back">
                    <h3>{variety.title}</h3>
                    <p>{variety.fullDesc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* View More Button */}
          {/* <div style={{ textAlign: "center", marginTop: "2rem" }}>
            <a
              href={soybeanVarietiesPdf}
              target="_blank"
              rel="noopener noreferrer"
              className="btn"
              style={{ backgroundColor: "#d4561a", color: "black" }}
            >
              📄 View More
            </a>
          </div> */}
        </div>
      </section>

      {/* Market Insights */}
      <section className="market-insights">
        <div className="container">
          <h2 data-aos="fade-up">Market Insights</h2>
          <p data-aos="fade-up">
            The Indo Pulses Development Association (IPDA) is set to expand its
            efforts into the pulses sector through a phased and strategic
            approach. The initiative begins with a strong focus on increasing
            consumer awareness about the nutritional benefits of pulses and
            food-based products, aiming to promote healthier dietary choices
            among the public. By educating consumers, IPDA seeks to build demand
            and trust in consumption of pulses.
          </p>
          <p data-aos="fade-up">
            In the subsequent phases, IPDA will facilitate market-led production
            by supporting farmers with resources, training, and access to
            innovation in pulses cultivation and processing. This integrated
            approach is designed to foster a robust and sustainable pulses food
            value chain—benefiting consumers, empowering farmers, and
            encouraging industry innovation. Through this initiative, IPDA
            reinforces its commitment to enhancing food security, nutrition, and
            agricultural sustainability in India.
          </p>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default AboutCommodity;
